let mhfiltrRunning = false;

function mhfiltr() {
    if (mhfiltrRunning) return;

    mhfiltrRunning = true;

    setTimeout(function () {
        mhfiltrRunning = false;
    }, 300);
    
    $('.filters-unveil-button-wrapper a').text(translation('filtrovat'));
    $('#category-filter-hover').append($('.slider-wrapper'), $('.filter-section-boolean'))
    if (!$('#filters > .close').length) {
        $('#filters').append('<span class="close"></span>');
    }
      $(document)
        .off('click.mhFilterClose', '#filters > .close, #cboxOverlay')
        .on('click.mhFilterClose', '#filters > .close, #cboxOverlay', function (e) {
            e.preventDefault();

            $('body').removeClass('filters-visible');
            $('#filters').removeClass('visible');

            $('.filters-unveil-button-wrapper a')
                .text(translation('filtrovat'));

            $('html').trigger('contentResized');
        });


   

    const $activeLabels = $('.filter-label.active');
    const hasActivePrice = getFilteredPriceRange() !== null;
    const hasActive = $activeLabels.length > 0 || hasActivePrice;

    let $wrapper = $('.chooseFilters');

    if (!hasActive) {
        $wrapper.remove();
    } else {

        if (!$wrapper.length) {
            $wrapper = $('<div class="chooseFilters"><div class="inner"></div></div>')
                .insertBefore('#category-header');
        }

        $wrapper.empty();

        // vytvoření struktury
        const $title = $('<div class="chooseFiltersTitle">' + translation('vaseFiltry') + '</div>').appendTo($wrapper);
        const $inner = $('<div class="inner"></div>').appendTo($wrapper);
        const $scrollbar = $('<div class="chooseFiltersScrollbar"><span></span></div>').appendTo($wrapper);

        $activeLabels.each(function () {
            $('body').addClass('activeFilters');
            $(this).closest('.filter-section').addClass('openFilter');

            const $label = $(this).clone();
            const filterName = $(this).closest('.filter-section').find('h4').first().text().replace('?', '');

            if (filterName) {
                $label.prepend('<span class="filterName">' + filterName + ': </span>');
            }

            // 👉 TADY JE HLAVNÍ ZMĚNA
            $inner.append($label);

        });
        appendPriceFilterToChooseFilters($inner);

        const $clear = $('#clear-filters');

        if ($clear.length) {
            const $clearClone = $clear.clone(true, true);

            $clearClone
                .addClass('clear-all-filters')
                .find('a')
                .text(translation('zrusitfiltry'));

            $wrapper.append($clearClone); // 👉 místo $inner
        }
    }
    openFiltersWithActiveValues();
    bindChooseFiltersFadeScroll();
    updateChooseFiltersFade();

    setTimeout(function () {
        bindChooseFiltersFadeScroll();
        updateChooseFiltersFade();
    }, 100);
    var orderList = getCategoryFilterOrder();

    if (!orderList) return;

    $('#category-filter-hover .filter-section').each(function () {

        var match = this.className.match(/filter-section-parametric-id-(\d+)/);
       // console.log(match)
        if (!match) return;

        var paramId = parseInt(match[1], 10);

        var index = orderList.indexOf(paramId);

        if (index !== -1) {
            // 👉 nastavíme order podle pořadí v array
            this.style.order = -100 + index;
        } else {
            // 👉 ostatní dáme dolů
            //this.style.order = 999;
        }

    });

}

if ($('#category-header').length) {
    $(document).ready(mhfiltr);
    document.addEventListener('ShoptetDOMPageContentLoaded', mhfiltr);
}

function getProductCountFromTopFilter() {

    const text = $('.param-filter-top .filter-count').first().text();

    if (!text) return 0;

    return parseInt(text.replace(/\s/g, ''), 10) || 0;
}

function showFilterHint() {

    const productCount = getProductCountFromTopFilter();

    if (productCount < maxfilterCount) return;
    if (sessionStorage.getItem('filterHintClosed')) return;
    if ($('.filterHintPopup').length) return;

    const popup = `
        <div class="filterHintPopup">
            <div class="filterHintContent">
                <div class="filterHintText">
                    <p>${filterCountText.replace('{count}', productCount)}</p>
                </div>
                <div class="filterHintClose">&times;</div>
            </div>
        </div>
    `;

    $('.filters-wrapper').prepend(popup);

    $('.filterHintClose').on('click', function () {
        $('.filterHintPopup').fadeOut(200, function () {
            $(this).remove();
        });
        sessionStorage.setItem('filterHintClosed', '1');
    });
}


// 🔁 společná inicializace (aby se to neopakovalo)
function initFilterHint() {
    showFilterHint();
}

$(document).ready(initFilterHint);
document.addEventListener('ShoptetDOMPageContentLoaded', initFilterHint);
document.addEventListener('ShoptetPageSortingChanged', initFilterHint);
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', initFilterHint);

if ($('body.mobile.type-category').length) {
    (function () {
        let pendingFilterUrl = null;
        let pendingProductsCount = null;
        function getCurrentTotalCount() {
            return $.trim($('.listItemsTotal strong').first().text());
        }
        function initFilterPanel() {
            if ($('.filtersApplyWrapper').length) return;
            $('#category-filter-hover').append(`
                <div class="filtersApplyWrapper">
                    <button class="applyFilters btn btn-primary">
                        ${translation('zobrazit')}
                        <span class="totalCount"></span>
                    </button>
                    <button class="resetFilters btn btn-secondary">
                        ${translation('zrusitVse')}
                    </button>
                </div>
            `);
            updateFilterButton();
        }

        function updateFilterButton() {
            const count = pendingProductsCount !== null
                ? pendingProductsCount
                : getCurrentTotalCount();

            $('.applyFiltersText').text(translation('zobrazit'));

            if (count) {
                $('.applyFilters .totalCount').text('(' + count + ')');
            } else {
                $('.applyFilters .totalCount').text('');
            }
        }


    /*    function updateFilterButton() {
            if (pendingProductsCount !== null) {
                $('.applyFilters').text(`${translation('filtrovat')} (${pendingProductsCount})`);
            }
        }*/

        $(document).on('click', '.filters-wrapper label.filter-label', function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            const inputId = $(this).attr('for');
            const $input = $('[id="' + inputId + '"]');
            if (!$input.length) return;
            const url = $input.data('url');
            if (!url) return;
            pendingFilterUrl = url;
            let openSections = [];
            $('.filter-section.openFilter').each(function () {
                const title = $(this).find('h4 span').text();
                openSections.push(title);
            });
            $.get(url, function (html) {
                const newSections = $(html).find('.filter-sections');
                const newCount = $(html).find('.filter-total-count strong').first().text();
                if (newSections.length) {
                    $('.filter-sections').html(newSections.html());

                }
                $('.filter-section').each(function () {
                    const title = $(this).find('h4 span').text();
                    if (openSections.includes(title)) {
                        $(this).addClass('openFilter');
                    }
                });
                if (newCount) {
                    pendingProductsCount = newCount;
                }
                updateFilterButton();
                initFilterPanel();
                customFilter(); //musíš přidat funkci na otevření zavřené filtrace a podobně
                openFiltersWithActiveValues();
                
            });
        });


        $(document).on('click', '.applyFilters', function () {
            if (!pendingFilterUrl) return;
            window.location.href = pendingFilterUrl;
        });


        $(document).on('click', '.resetFilters', function () {
            window.location.href = window.location.pathname;
        });
        $(document).ready(function () {
            initFilterPanel();
        });
        document.addEventListener('ShoptetDOMContentLoaded', function () {
            initFilterPanel();
        });
    })();
}

function getCategoryId() {
    var match = document.body.className.match(/\bid-(\d+)\b/);
    return match ? parseInt(match[1], 10) : null;
}


function openFiltersWithActiveValues() {
    $('.filter-section').each(function () {
        const $section = $(this);
        const hasActiveValue = $section.find('.filter-label.active').length > 0;

        if (!hasActiveValue) return;

        $section.addClass('openFilter');

        // nastavíme interní stav jako rozbalený
        $section.data('expanded', true);

        // zobrazí schované hodnoty uvnitř daného filtru
        $section.find('fieldset > div').show();

        // přepne tlačítko
        const $button = $section.find('.filterShowMore');

        if ($button.length) {
            $button
                .removeClass('more')
                .addClass('less')
                .text(translation('rozbalitMene'));
        }
    });
}


$(document).on('click', '.chooseFilters label.filter-label', function () {
    const scrollTop = $(window).scrollTop();

    requestAnimationFrame(function () {
        $(window).scrollTop(scrollTop);
    });

    setTimeout(function () {
        $(window).scrollTop(scrollTop);
    }, 50);
});

function getCategoryFilterOrder() {
    var categoryId = getCategoryId();

    // 1. Přesná shoda podle ID má vždy přednost
    if (categoryId && categoryFilterOrder[categoryId]) {
        return categoryFilterOrder[categoryId];
    }

    // 2. Fallback podle URL v breadcrumbs
    return getCategoryFilterOrderByBreadcrumbUrl();
}

function getCategoryFilterOrderByBreadcrumbUrl() {
    var breadcrumbUrls = getBreadcrumbUrls();
    var matchedOrder = null;
    var matchedIndex = -1;

    Object.keys(categoryFilterOrderByPath).forEach(function(path) {
        var normalizedPath = normalizeCategoryPath(path);

        breadcrumbUrls.forEach(function(breadcrumbUrl, index) {
            // čím později v breadcrumbs, tím konkrétnější kategorie
            if (breadcrumbUrl === normalizedPath && index > matchedIndex) {
                matchedOrder = categoryFilterOrderByPath[path];
                matchedIndex = index;
            }
        });
    });

    return matchedOrder;
}

function getBreadcrumbUrls() {
    var urls = [];

    $('.breadcrumbs [itemprop="item"]').each(function() {
        var url = '';

        if ($(this).is('a')) {
            url = $(this).attr('href');
        } else if ($(this).is('meta')) {
            url = $(this).attr('content');
        }

        url = normalizeCategoryPath(url);

        if (url && url !== '/') {
            urls.push(url);
        }
    });

    return urls;
}

function normalizeCategoryPath(path) {
    if (!path) {
        return '';
    }

    // odstraní doménu, např. https://domain.cz/neco/
    path = path.replace(/^https?:\/\/[^/]+/i, '');

    // odstraní protocol-relative doménu, např. //localhost:3000/neco/
    path = path.replace(/^\/\/[^/]+/i, '');

    // odstraní query/hash
    path = path.split('?')[0].split('#')[0];

    if (path.charAt(0) !== '/') {
        path = '/' + path;
    }

    if (path.charAt(path.length - 1) !== '/') {
        path += '/';
    }

    return path;
}


function updateChooseFiltersFade() {
    $('.chooseFilters').each(function () {
        const $wrapper = $(this);
        const $inner = $wrapper.find('.inner').first();

        if (!$inner.length) return;

        let $scrollbar = $wrapper.children('.chooseFiltersScrollbar');

        if (!$scrollbar.length) {
            $scrollbar = $('<div class="chooseFiltersScrollbar"><span></span></div>');
            $wrapper.append($scrollbar);
        }

        const el = $inner[0];

        const maxScroll = el.scrollWidth - el.clientWidth;
        const scrollLeft = el.scrollLeft;

        const hasOverflow = maxScroll > 2;
        const isStart = scrollLeft <= 2;
        const isEnd = !hasOverflow || scrollLeft >= maxScroll - 2;

        $wrapper.toggleClass('hasFilterOverflow', hasOverflow);
        $wrapper.toggleClass('isScrolledStart', hasOverflow && isStart);
        $wrapper.toggleClass('isScrolledEnd', hasOverflow && isEnd);

        if (!hasOverflow) {
            $scrollbar.hide();
            return;
        }

        $scrollbar.show();

        const trackWidth = $scrollbar.outerWidth();

        if (!trackWidth) return;

        const thumbWidth = Math.max((el.clientWidth / el.scrollWidth) * trackWidth, 32);
        const maxThumbMove = trackWidth - thumbWidth;
        const thumbLeft = maxScroll > 0 ? (scrollLeft / maxScroll) * maxThumbMove : 0;

        $scrollbar.find('span').css({
            width: thumbWidth + 'px',
            transform: 'translateX(' + thumbLeft + 'px)'
        });
    });
}

function bindChooseFiltersFadeScroll() {
    $('.chooseFilters .inner').each(function () {
        const el = this;

        if (el.dataset.fadeBound === '1') return;

        el.dataset.fadeBound = '1';

        el.addEventListener('scroll', function () {
            requestAnimationFrame(updateChooseFiltersFade);
        }, { passive: true });

        el.addEventListener('touchmove', function () {
            requestAnimationFrame(updateChooseFiltersFade);
        }, { passive: true });
    });
}


$(document).on('scroll', '.chooseFilters .inner', function () {
    requestAnimationFrame(updateChooseFiltersFade);
});

function getFilteredPriceRange() {
    const $sliderWrapper = $('.slider-wrapper').first();

    if (!$sliderWrapper.length) {
        return null;
    }

    const currentMinText = $.trim($sliderWrapper.find('#min').text());
    const currentMaxText = $.trim($sliderWrapper.find('#max').text());

    const categoryMinText = $.trim($sliderWrapper.find('#categoryMinValue').text());
    const categoryMaxText = $.trim($sliderWrapper.find('#categoryMaxValue').text());

    if (!currentMinText || !currentMaxText || !categoryMinText || !categoryMaxText) {
        return null;
    }

    const currentMin = parseInt(currentMinText.replace(/\s/g, ''), 10);
    const currentMax = parseInt(currentMaxText.replace(/\s/g, ''), 10);

    const categoryMin = parseInt(categoryMinText.replace(/\s/g, ''), 10);
    const categoryMax = parseInt(categoryMaxText.replace(/\s/g, ''), 10);

    if (
        isNaN(currentMin) ||
        isNaN(currentMax) ||
        isNaN(categoryMin) ||
        isNaN(categoryMax)
    ) {
        return null;
    }

    const isPriceFiltered = currentMin !== categoryMin || currentMax !== categoryMax;

    if (!isPriceFiltered) {
        return null;
    }

    return {
        min: currentMinText,
        max: currentMaxText
    };
}

function appendPriceFilterToChooseFilters($inner) {
    const price = getFilteredPriceRange();
    if (!price) {
        return false;
    }

    const $priceLabel = $(`
        <label class="filter-label active price-filter-label">
            <span class="filterName">${translation('cena')}: </span>
            ${Number(price.min.replace(/\s/g, '').replace(',', '.')).ShoptetFormatAsCurrency()} – ${Number(price.max.replace(/\s/g, '').replace(',', '.')).ShoptetFormatAsCurrency()}
        </label>
    `);

    $inner.append($priceLabel);

    $('.slider-wrapper').addClass('openFilter');
    $('body').addClass('activeFilters');

    return true;
}

$('html')
    .off('click.mhFilterOpenFix', '.filters-unveil-button-wrapper [data-unveil="filters"]')
    .on('click.mhFilterOpenFix', '.filters-unveil-button-wrapper [data-unveil="filters"]', function () {
        setTimeout(function () {
            if (!$('#filters').hasClass('visible')) {
                $('#filters').addClass('visible');
                $('body').addClass('filters-visible');
                $('html').trigger('contentResized');
            }
        }, 30);
    });